import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(web)/pricing/page.tsx");
